import { t } from "@/i18n-js/instance";
import { useSelectedBlock } from "@circle-react-shared/BuilderUI";
import { Typography } from "@circle-react-uikit/Typography";
import { EditorForm } from "./EditorForm";

export const Editor = () => {
  const { selectedBlock, meta } = useSelectedBlock();

  if (!selectedBlock || !meta) {
    return (
      <div className="px-6 py-5">
        <Typography.BodyMd>
          {t("builder_ui.editor.select_a_block")}
        </Typography.BodyMd>
      </div>
    );
  }

  return <EditorForm selectedBlock={selectedBlock} meta={meta} />;
};
